import type { TourStep } from '@/types/help-tour';
import { buildTourSteps, type TourStepDef } from '@/utils/tourI18n';

const STEP_DEFS: TourStepDef[] = [
  { target: '[data-tour="profile-hero"]' },
  { target: '[data-tour="profile-sections"]' },
  { target: '#tab-memories' }
];

export const PERSON_PROFILE_TOUR_STEPS: TourStep[] = buildTourSteps('personProfile', STEP_DEFS);

export const PERSON_PROFILE_TOUR_STORAGE_KEY = 'wetree-person-profile-tour-completed';
